// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1___6108c952ad17fa9da94","cls2":"CreateSocialItem-cls2___ccb7874ebbaa707859b CreateSocialItem-cls1___6108c952ad17fa9da94"};